import calculateReservationCapacity from './original/calculateReservationCapacity';
import selectSeatingsByReservationHash from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors/selectSeatingsByReservationHash';
import {
    OBJECT_TYPE_GENERAL_ADMISSION,
    OBJECT_TYPE_SEAT,
} from '%paysera_seat_selection/js/seatSelection/config/constants';

export default function (reservation) {
    return (dispatch, getState) => {
        const seatings = selectSeatingsByReservationHash(getState(), reservation.hash);

        const generalAdmissions = seatings.filter(seating => seating.objectType === OBJECT_TYPE_GENERAL_ADMISSION);
        const seats = seatings.filter(seating => seating.objectType === OBJECT_TYPE_SEAT);

        dispatch(calculateReservationCapacity({ reservation, generalAdmissions, seats }));
    };
}
